import CryptoJS from "crypto-js";

export const AESDecryptJSON = (message) => {
  if (message) {
    const decrypted = CryptoJS.AES.decrypt(message, process.env.NODE_ENV);
    const decryptedMessage = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedMessage);
  }
  return message;
};

export const AESDecryptString = (message) => {
  if (message) {
    const decrypted = CryptoJS.AES.decrypt(message, process.env.NODE_ENV);
    const decryptedMessage = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedMessage;
  }
  return message;
};

export const AESDecryptURL = (message) => {
  if (message) {
    const decodeMessage = message
      ?.toString()
      .replaceAll("xMl3Jk", "+")
      .replaceAll("Por21Ld", "/")
      .replaceAll("Ml32", "=");
    const decrypted = CryptoJS.AES.decrypt(decodeMessage, process.env.NODE_ENV);
    return decrypted?.toString(CryptoJS.enc.Utf8);
  }
  return message;
};
